import * as React from "react"
import Breadcrumb from "./Breadcrub"

const Mv = ({
  title,
  title_sp,
  subtitle,
  description,
  description_sp,
  bg_img,
  bg_imgx2,
  postTitle,
  location,
}) => {
  return (
    <>
      <div className="mv">
        <div className="mv__bg">
          <img
            src={bg_img}
            srcset={`${bg_img} 1x, ${bg_imgx2} 2x`}
            alt={title}
          />
        </div>
        <div className="mv__container">
          <div className="mv__content">
            <p>
              <span>{subtitle} </span>
            </p>
            <h1 className="mv__title-pc">{title}</h1>
            <h1 className="mv__title-sp">{title_sp || title}</h1>
            <p className="mv__description-pc">{description}</p>
            <p className="mv__description-sp">
              {description_sp || description}
            </p>
          </div>
        </div>
      </div>
      {location ? <Breadcrumb location={location} postTitle={postTitle} /> : ""}
    </>
  )
}

export default Mv
